import React from "react";
import { Octokit } from "@octokit/rest";
import SiteLayout from "../../components/layout/SiteLayout";
import PageIntro from "../../components/ui/PageIntro";
import {
  FaGithub,
  FaMobileAlt,
  FaExternalLinkAlt,
  FaGlobe,
  FaArrowRight,
} from "react-icons/fa";

export default class ProjectsPage extends React.Component {
  constructor() {
    super();
    this.state = {
      githubProjects: [],
    };
  }

  componentDidMount() {
    const octokit = new Octokit({
      auth: process.env.REACT_APP_GITHUB_TOKEN,
      userAgent: "vishwaram.com",
    });

    octokit.rest.repos
      .listForUser({
        username: "vishwaramm",
      })
      .then((resp) => {
        if (resp && resp.data) {
          this.setState({ githubProjects: resp.data });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderMobileAppCard({
    title,
    description,
    iconUrl,
    appStoreUrl,
    supportUrl,
    privacyUrl,
    subtitle,
  }) {
    return (
      <article className="home-v3-panel">
        <span className="home-v3-kicker">
          <FaMobileAlt /> Mobile App
        </span>
        <div className="home-v3-app-tile" style={{ justifyItems: "start" }}>
          <div className="home-v3-phone">
            <div className="home-v3-phone-screen">
              <img
                className="home-v3-app-icon"
                alt={`${title} App Store icon`}
                src={iconUrl}
              />
            </div>
          </div>
          <div className="home-v3-app-copy">
            <strong>{title}</strong>
            <span>{description}</span>
            <em>{subtitle}</em>
          </div>
        </div>
        <div className="home-v3-actions project-app-actions">
          <a href={appStoreUrl} target="_blank" rel="noreferrer" className="home-v3-button is-primary">
            View App <FaArrowRight />
          </a>
          {supportUrl ? (
            <a href={supportUrl} className="home-v3-button is-secondary">
              Support <FaExternalLinkAlt />
            </a>
          ) : null}
          {privacyUrl ? (
            <a href={privacyUrl} className="home-v3-button is-secondary">
              Privacy <FaExternalLinkAlt />
            </a>
          ) : null}
        </div>
      </article>
    );
  }

  render() {
    const { githubProjects } = this.state;

    return (
      <SiteLayout>
        <main className="page-shell home-v3-shell projects-page">
          <div className="home-v3-frame">
            <PageIntro
              eyebrow="Professional / Projects"
              title="Build, ship, keep improving."
              description="A working shelf of mobile apps, websites, and public code — focused on useful software that stays live."
              actions={[
                { label: "View apps", href: "#apps", variant: "primary" },
                { label: "View repos", href: "#github", variant: "secondary" },
              ]}
              image={{
                src: `${process.env.PUBLIC_URL}/assets/projects-hero-circle.png`,
                className: "projects-page-intro-image",
              }}
            />

            <section className="home-v3-band" id="apps">
              <div className="home-v3-band-label">
                <span className="home-v3-kicker">Apps</span>
                <h2>Mobile apps I keep live.</h2>
              </div>
              <div className="home-v3-band-content home-v3-app-row">
                  {this.renderMobileAppCard({
                    title: "Body Analyzer",
                    description: "I use this for health and body-composition tracking.",
                    subtitle: "iOS app",
                    iconUrl:
                      "https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/92/a2/4d/92a24dfc-1331-de5d-2896-0225387d4c09/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/460x0w.webp",
                    appStoreUrl:
                      "https://apps.apple.com/us/app/body-analyzer-plus/id1489053077?itsct=apps_box_badge&itscg=30200",
                    supportUrl: "/support?app=body-analyzer",
                    privacyUrl: "/privacy?app=body-analyzer",
                  })}
                  {this.renderMobileAppCard({
                    title: "Meditation Counter",
                    description: "I use this to track meditation repetitions.",
                    subtitle: "iOS app",
                    iconUrl:
                      "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/06/5f/70/065f70c2-cbb2-ab55-8a91-e2c063b0420d/AppIcon-0-0-1x_U007emarketing-0-7-0-0-85-220.png/180x0w.png",
                    appStoreUrl:
                      "https://apps.apple.com/us/app/meditation-counter/id1559832205",
                    supportUrl: "/support?app=meditation-counter",
                    privacyUrl: "/privacy?app=meditation-counter",
                  })}
                  {this.renderMobileAppCard({
                    title: "Neon Jumper 199X",
                    description:
                      "I published this retro runner for quick, high-score play.",
                    subtitle: "iOS game",
                    iconUrl:
                      "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/14/52/41/145241e8-fb56-e991-42de-38c7da05fcff/AppIcon-0-0-1x_U007epad-0-1-85-220.png/512x512bb.jpg",
                    appStoreUrl:
                      "https://apps.apple.com/gb/app/neon-jumper-199x/id6760213808",
                    supportUrl: "/support?app=neon-jumper-199x",
                    privacyUrl: "/privacy?app=neon-jumper-199x",
                  })}
                  {this.renderMobileAppCard({
                    title: "Crystal Relics",
                    description:
                      "I published this score-driven puzzle game for fast, strategic runs.",
                    subtitle: "iOS game",
                    iconUrl:
                      "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/25/27/eb/2527eb3d-1fc2-e00b-6658-72624fe130c0/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg",
                    appStoreUrl:
                      "https://apps.apple.com/us/app/crystal-relics/id6761284126",
                    supportUrl: "/support?app=crystal-relics",
                    privacyUrl: "/privacy?app=crystal-relics",
                  })}
              </div>
            </section>

            <section className="home-v3-band">
              <div className="home-v3-band-label">
                <span className="home-v3-kicker">Websites</span>
                <h2>Sites I have built.</h2>
              </div>
              <div className="home-v3-band-content home-v3-pillars" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
                <article className="home-v3-panel">
                  <span className="home-v3-kicker">
                    <FaGlobe /> Website
                  </span>
                  <h3>Gouri Shankar Mandir</h3>
                  <p>Mandir website.</p>
                  <a className="home-v3-button is-secondary" href="http://www.gourishankarmandir.com" target="_blank" rel="noreferrer">
                    Visit Site <FaExternalLinkAlt />
                  </a>
                </article>
                <article className="home-v3-panel">
                  <span className="home-v3-kicker">
                    <FaGlobe /> Website
                  </span>
                  <h3>The Hindu Society</h3>
                  <p>Non-profit religious website.</p>
                  <a className="home-v3-button is-secondary" href="https://thehindusociety.com" target="_blank" rel="noreferrer">
                    Visit Site <FaExternalLinkAlt />
                  </a>
                </article>
              </div>
            </section>

            <section className="home-v3-band" id="github">
              <div className="home-v3-band-label">
                <span className="home-v3-kicker">GitHub</span>
                <h2>Repositories I keep public.</h2>
              </div>
              <div className="home-v3-band-content home-v3-pillars" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
                {githubProjects
                  .filter((project) => !project.private)
                  .slice(0, 4)
                  .map((project) => (
                    <article className="home-v3-panel" key={project.name}>
                      <span className="home-v3-kicker">GitHub</span>
                      <h3>{project.name}</h3>
                      <p>{project.description || "No description provided."}</p>
                      <div className="pill-list">
                        <span className="pill">{project.language || "Code"}</span>
                        <span className="pill">Updated work</span>
                      </div>
                      <a className="home-v3-button is-secondary" href={project.html_url} target="_blank" rel="noreferrer">
                        Open Repo <FaGithub />
                      </a>
                    </article>
                  ))}
              </div>
            </section>

            <section className="home-v3-band">
              <div className="home-v3-band-label">
                <span className="home-v3-kicker">Experiments</span>
                <h2>Experiments I keep live.</h2>
              </div>
              <div className="home-v3-band-content home-v3-pillars" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
                <a className="home-v3-panel" href="/professional/apps/maze-generator">
                  <span className="home-v3-kicker">Generator</span>
                  <h3>Maze Generator</h3>
                  <p>Procedural maze generator.</p>
                  <span className="home-v3-button is-secondary">Open App <FaArrowRight /></span>
                </a>
                <a className="home-v3-panel" href="/professional/apps/financial-risk">
                  <span className="home-v3-kicker">Calculator</span>
                  <h3>Finance Calculator</h3>
                  <p>Financial risk calculator.</p>
                  <span className="home-v3-button is-secondary">Open App <FaArrowRight /></span>
                </a>
              </div>
            </section>
          </div>
        </main>
      </SiteLayout>
    );
  }
}
